import { jwtPayload } from "@insightfulscience/shared-utils/jwt/jwtPayload";

/** @type {(token: { exp: number }) => boolean} */
export const isNotExpired = token => token && token.exp * 1000 > Date.now();

/** @type {(token: string) => boolean} */
export const isTokenValid = token => Boolean(token) && jwtPayload(token) != null;
